import { useCallback, useEffect, useState } from 'react';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router';
import { navigationService } from './shared/utils/navigation';
import MaintenancePage from './pages/Maintenance/MaintenancePage';

function App() {
  const [bypassed, setBypassed] = useState(
    () => localStorage.getItem('maintenance_bypassed') === 'true'
  );
  const handleBypass = useCallback(() => {
    localStorage.setItem('maintenance_bypassed', 'true');
    setBypassed(true);
  }, []);

  useEffect(() => {
    // Initialize navigation service with router instance
    navigationService.initialize(router);
  }, []);

  if (false) {
    return <MaintenancePage onBypass={handleBypass} />;
  }

  return <RouterProvider router={router} />;
}

export default App;
